const primaryFontFamily = 'Inter';
const primaryColor = 'rgba(255, 255, 255, 1)'; // White for primary text
const secondaryColor = 'rgba(133, 0, 27, 1)'; // Deep red for accents
const backgroundColor = 'rgba(254, 254, 254, 1)'; // Near-white background
const borderColor = 'rgba(255, 255, 255, 1)'; // White for borders

export const mainColors = {
  primaryColor: 'rgb(0, 0, 0)',
  secondaryColor,
  backgroundColor,
  borderColor,
};

export const theme = {
  headline: {
    fontFamily: primaryFontFamily,
    color: primaryColor,
  },
  text: {
    fontFamily: primaryFontFamily,
    color: primaryColor,
  },
  spacer: {
    color: 'rgba(0, 0, 0, 0)', // Transparent
  },
  button: {
    fontFamily: primaryFontFamily,
    color: primaryColor,
    borderColor: primaryColor,
    backgroundColor: secondaryColor,
  },
  rank: {
    baseColor: secondaryColor,
  },
  image: {
    backgroundColor: 'rgba(0, 0, 0, 0)', // Transparent
  },
  field: {
    fontFamily: primaryFontFamily,
    color: 'rgb(0, 0, 0)', // Black text
    borderColor: primaryColor,
    backgroundColor: backgroundColor,
  },
  social: {
    color: 'rgb(0, 0, 0)', // Black text
  },
  survey: {
    fontFamily: primaryFontFamily,
    color: backgroundColor, // Near-white text
    borderColor: 'rgb(0, 0, 0)', // Black border
    backgroundColor: 'rgba(0, 0, 0, 1)', // Black background
  },
  wheel: {
    fontFamily: primaryFontFamily,
    color: backgroundColor, // Near-white text
    borderColor: 'rgb(0, 0, 0)', // Black border
    backgroundColor: 'rgba(0, 0, 0, 1)', // Black background
    secondaryBackgroundColor: secondaryColor, // Deep red background
  },
  voucher: {
    fontFamily: primaryFontFamily,
    fontWeight: 'bold',
    color: primaryColor,
    borderColor: primaryColor,
  },
  checkbox: {
    color: primaryColor, // White checkmark
    borderColor: 'rgba(255, 255, 255, 0)', // Transparent border
    checkboxColor: primaryColor, // White checkbox
    backgroundColor: 'rgba(0, 0, 0, 1)', // Black background
  },
};

export default {
  theme,
  mainColors,
};
